import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { PAGE_HEIGHT } from '../constants';

export default function ErrorPage({ children }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      style={{ height: PAGE_HEIGHT, paddingTop: '200px', margin: '0 20px' }}
    >
      {children}
    </Box>
  );
}

ErrorPage.propTypes = {
  children: PropTypes.any,
};

export function ErrorMessage({ message }) {
  return (
    <Typography variant="h2" color="error">
      {message}
    </Typography>
  );
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export function ErrorButtons({ children }) {
  return (
    <Box display="flex" justifyContent="center" style={{ width: '100%' }}>
      {children}
    </Box>
  );
}

ErrorButtons.propTypes = {
  children: PropTypes.any,
};

export function ErrorHome() {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate('/')}
      color="primary"
      variant="contained"
      style={{ margin: '10px 5px' }}
      disableElevation
    >
      Home
    </Button>
  );
}

export function ErrorBack() {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(-1)}
      color="primary"
      variant="contained"
      style={{ margin: '10px 5px' }}
      disableElevation
    >
      Back
    </Button>
  );
}
